import Grid from '@mui/material/Grid';
import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete.tsx';
import type { Option, OptionsMap } from '@openx/types/options.ts';
import type { ContentObjectAction, ContentObjectOption } from '@openx/types/targeting/contentObject.ts';
import { useCallback } from 'react';

import { getOptionName, inputPlaceholder } from '../../constants.ts';

export const StaticOptions = (props: {
  loading;
  options: OptionsMap;
  dispatch: (action: ContentObjectAction) => void;
  type: ContentObjectOption;
}) => {
  const { loading, options, dispatch, type } = props;
  const tempOptions = Object.keys(options).reverse();
  const onChange = useCallback(
    (value: Option | null) => {
      dispatch({ type, values: value });
    },
    [dispatch, type]
  );

  return (
    <Grid size={9}>
      <AutoComplete
        loading={loading}
        options={tempOptions}
        getOptionLabel={chosenOption => options[chosenOption]?.name || ''}
        onChange={(_, value) => (value ? onChange(options[value]) : onChange(null))}
        textFieldProps={{ label: getOptionName(type), placeholder: inputPlaceholder(type) }}
        data-test="content-object-input"
      />
    </Grid>
  );
};
